
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from "@dnd-kit/utilities";
import Caption from '../../components/Typography/Caption';
import DotVRIcon from '../../icons/DotVRIcon';

type SortableCategoryProps = {
    category: any;
    handleClick: (categoryId: number) => void;
    selected: any;
    selectedSnapshots: Array<any>;
}


const SortableCategory: React.FC<SortableCategoryProps> = ({category, handleClick, selected, selectedSnapshots}): React.ReactElement => {
    const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: category.id, data: {category} });
    
    const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    };

    return (
        <div 
        ref={setNodeRef}
        style={style}
        key={category.id}
        className={`flex flex-col bg-gray-300 border-b-2 px-2 py-2 ${selected === category.id ? "bg-gray-400": ""}`}>
            <div className='flex items-center'>
                <DotVRIcon {...attributes} {...listeners} className="w-4 h-4 mr-2 cursor-move"/>
                <Caption onClick={(e:any) => handleClick(category.id)} classes='cursor-pointer p-4 grow'>{category.name}</Caption>
            </div>
        </div>
    );
}

export default SortableCategory;